import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";

const TooltipOption = () => {
  return (
    <>
      {/* <div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
        >
          <Link to="#" className="btn btn-outline-light bg-white btn-icon me-1">
            <i className="ti ti-refresh" />
          </Link>
        </OverlayTrigger>
      </div>
      <div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Print</Tooltip>}
        >
          <button
            type="button"
            className="btn btn-outline-light bg-white btn-icon me-1"
          >
            <i className="ti ti-printer" />
          </button>
        </OverlayTrigger>
      </div> */}
      <div className="me-2 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Import</Tooltip>}
        >
          <Link
            to={all_routes.importStudents}
            className="btn btn-light fw-medium d-inline-flex align-items-center"
          >
            <i className="ti ti-file-import me-2" />
            Import
          </Link>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default TooltipOption;
